import { render, staticRenderFns } from "./PatientOutClinicInvoice.vue?vue&type=template&id=0c8ade4a&scoped=true"
import script from "./PatientOutClinicInvoice.vue?vue&type=script&lang=js"
export * from "./PatientOutClinicInvoice.vue?vue&type=script&lang=js"
import style0 from "./PatientOutClinicInvoice.vue?vue&type=style&index=0&id=0c8ade4a&prod&scoped=true&lang=css"
import style1 from "./PatientOutClinicInvoice.vue?vue&type=style&index=1&id=0c8ade4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ade4a",
  null
  
)

export default component.exports